<ng-container *ngIf="!user.isInstructor">
  <div class="project_widget">
    <div class="header">
      <h2><strong>Account Notifications</strong></h2>
    </div>
    <div class="body">
      <div class="row">
        <div class="col-md-3 col-6 b-r">
          <ul class="list-group" class="p-3">
            <li class="">
              <mat-slide-toggle [(ngModel)]="userCommunications.receiveAccountEmailNotifications"
                (ngModelChange)="ngCommunicationChanged('')">Email
              </mat-slide-toggle>
            </li>
            <li>
              <mat-slide-toggle [(ngModel)]="userCommunications.receiveAccountTextNotifications"
                (ngModelChange)="ngCommunicationChanged('')">SMS
              </mat-slide-toggle>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="header">
      <h2><strong>Instructor Notifications</strong></h2>
    </div>
    <div class="body">
      <div class="row">
        <div class="col-md-3 col-6 b-r">
          <ul class="list-group" class="p-3">
            <li class="">
              <mat-slide-toggle [(ngModel)]="userCommunications.receiveInstructorEmailNotifications"
                (ngModelChange)="ngCommunicationChanged('')">Email
              </mat-slide-toggle>
            </li>
            <li>
              <mat-slide-toggle [(ngModel)]="userCommunications.receiveInstructorTextNotifications"
                (ngModelChange)="ngCommunicationChanged('')">SMS
              </mat-slide-toggle>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="header">
      <h2><strong>Marketing Notifications</strong></h2>
    </div>
    <div class="body">
      <div class="row">
        <div class="col-md-3 col-6 b-r">
          <ul class="list-group" class="p-3">
            <li class="">
              <mat-slide-toggle [(ngModel)]="userCommunications.receiveMarketingEmailNotifications"
                (ngModelChange)="ngCommunicationChanged('')">Email
              </mat-slide-toggle>
            </li>
            <li>
              <mat-slide-toggle [(ngModel)]="userCommunications.receiveMarketingTextNotifications"
                (ngModelChange)="ngCommunicationChanged('')">SMS
              </mat-slide-toggle>
            </li>
          </ul>
        </div>
      </div>
    </div>

  </div>
</ng-container>
<ng-container *ngIf="user.isInstructor">
  <mat-tab-group mat-align-tabs="start">
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="example-tab-icon msr-2">mail</mat-icon>
        Email Messaging
      </ng-template>
      <div class="header">
        <h2><strong>Emails sent to students</strong></h2>
      </div>
      <div class="body">
        <div class="row">
          <div class="col-3">
            <mat-label>Select Message Template</mat-label>
            <br />
            <mat-select [(value)]="selected" (selectionChange)="templateSelected($event)">
              <mat-option *ngFor="let msg of messaging " [value]="msg">{{msg.label}}</mat-option>
            </mat-select>
          </div>
          <div class="col-3">
            <div class="d-flex justify-content-center">
              <button class=" bg-dol-green" mat-flat-button (click)="sendTestEmail()">Send Test Email</button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-8">
            <br />
            <div *ngIf="noIntro" class="alert alert-danger"><span class="red">**</span> No introductions are being sent
              to your customers when they book a session. Click Save Changes to update the email template.<span
                class="red">**</span></div>
            <div *ngIf="noUpsell" class="alert alert-danger"><span class="red">**</span> No email is being sent to help
              market your self for future reservations. Click Save Changes to update the email template.<span
                class="red">**</span></div>
          </div>
        </div>
        <br />
        <br />
        <div class="row">
          <div class="col-8">
            <ckeditor [editor]="Editor" (change)="onChange($event)" [data]="template"></ckeditor>
          </div>
        </div>
      </div>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="example-tab-icon msr-2">settings</mat-icon>
        Thrive Message Settings
      </ng-template>
      <div class="project_widget">
        <div class="header">
          <h2><strong>Account Notifications</strong></h2>
        </div>
        <div class="body">
          <div class="row">
            <div class="col-md-3 col-6 b-r">
              <ul class="list-group" class="p-3">
                <li class="">
                  <mat-slide-toggle [(ngModel)]="userCommunications.receiveAccountEmailNotifications"
                    (ngModelChange)="ngCommunicationChanged('')">Email
                  </mat-slide-toggle>
                </li>
                <li>
                  <mat-slide-toggle [(ngModel)]="userCommunications.receiveAccountTextNotifications"
                    (ngModelChange)="ngCommunicationChanged('')">SMS
                  </mat-slide-toggle>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="header">
          <h2><strong>Instructor Notifications</strong></h2>
        </div>
        <div class="body">
          <div class="row">
            <div class="col-md-3 col-6 b-r">
              <ul class="list-group" class="p-3">
                <li class="">
                  <mat-slide-toggle [(ngModel)]="userCommunications.receiveInstructorEmailNotifications"
                    (ngModelChange)="ngCommunicationChanged('')">Email
                  </mat-slide-toggle>
                </li>
                <li>
                  <mat-slide-toggle [(ngModel)]="userCommunications.receiveInstructorTextNotifications"
                    (ngModelChange)="ngCommunicationChanged('')">SMS
                  </mat-slide-toggle>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="header">
          <h2><strong>Marketing Notifications</strong></h2>
        </div>
        <div class="body">
          <div class="row">
            <div class="col-md-3 col-6 b-r">
              <ul class="list-group" class="p-3">
                <li class="">
                  <mat-slide-toggle [(ngModel)]="userCommunications.receiveMarketingEmailNotifications"
                    (ngModelChange)="ngCommunicationChanged('')">Email
                  </mat-slide-toggle>
                </li>
                <li>
                  <mat-slide-toggle [(ngModel)]="userCommunications.receiveMarketingTextNotifications"
                    (ngModelChange)="ngCommunicationChanged('')">SMS
                  </mat-slide-toggle>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</ng-container>